import { PERMISSIONS, ROLES } from '../constants/roles'

export const hasPermission = (
  userRoles: ROLES[],
  rolesMapping: Record<ROLES, PERMISSIONS[]>,
  permissionToCheck: PERMISSIONS
) => {
  if (permissionToCheck === undefined) {
    return true
  }

  const userPermissions = userRoles.flatMap(role => rolesMapping[role] || [])
  const userPermissionsWithoutDuplicates = [...new Set(userPermissions)]
  return userPermissionsWithoutDuplicates.includes(permissionToCheck)
}
